// extracted by mini-css-extract-plugin
export default {"column__container":"styles_column__container__bKXvI","detail__button":"styles_detail__button__o7I4h"};